import { render, staticRenderFns } from "./AssessmentMemberModal.vue?vue&type=template&id=247749e7&"
import script from "./AssessmentMemberModal.vue?vue&type=script&lang=js&"
export * from "./AssessmentMemberModal.vue?vue&type=script&lang=js&"
import style0 from "./AssessmentMemberModal.vue?vue&type=style&index=0&id=247749e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports